
import React, { useState, useEffect, useRef } from "react";
import {
  Layout,
  Row,
  Col,
  Breadcrumb,
  Steps,
  Button,
  message,
  Spin,
  Card,
  Form,
} from "antd";
import { LoadingOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { BsXCircleFill, BsDownload, BsCloudUpload, BsFillCheckCircleFill } from "react-icons/bs";

import axios from 'axios';
import AddSingleProperty from "./AddSingleProperty";
import { Controller, useForm } from "react-hook-form";
import {
  propertyService, serverUrl
} from "../../../../configs/constants";
import type { UploadFile } from 'antd/es/upload/interface';
import { InboxOutlined } from '@ant-design/icons';


import { CSVLink } from "react-csv";

import { Upload } from 'antd';
import { RcFile } from "antd/lib/upload/interface";
import Address from "./components/AddInformation/Address";
import { formatFileExtensions } from "../../../libs/utils";
import { UPLOAD_CONFIG } from "../../../libs/constants";

const { Dragger } = Upload;
const { Content } = Layout;

var _ = require("lodash");




export default (props) => {

  const initials = { unit: 0, building: 0 };
  const [failedData, setFailed] = useState([]);
  const [successData, setSuccess] = useState(initials);
  const [loading, setLoading] = useState(false);

  const { control, formState: { errors }, setValue, handleSubmit } = useForm();

  const headers = [
    { label: "Business Unit Name", key: "businessunit" },
    { label: "Building Name", key: "buildingname" },
    { label: "Property Code", key: "propertycode" },
    { label: "Unit Code", key: "unitcode" },
    { label: "Reason", key: "reason" }
  ];

  const csvReport = {
    data: failedData,
    headers: headers,
    filename: 'Property_Failure_log.csv'
  };

  const [propertyFile, setProperty] = useState<UploadFile[]>([]);


  const status = () => {
    let text = "";
    if (successData.building > 0 && successData.unit > 0) {
      text = ` Successfully Added  ${successData.building} Buildings and ${successData.unit} Units`;
    }
    else if (successData.building > 0 && successData.unit == 0)
      text = `Successfully Added ${successData.building} Buildings`;
    else if (successData.building == 0 && successData.unit > 0)
      text = `Successfully Added ${successData.unit} Units`;
    else
      text = "";
    return text;
  }

  const resetModal = () => {
    setProperty([]);
    setFailed([]);
    setSuccess(initials);
  }

  const onFinish = async (values) => {



    resetModal();
    setLoading(true);



    if (propertyFile[0]) {

      let fd = new FormData();
      fd.append('file_asset', propertyFile[0] as RcFile);
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      const url = `${propertyService}/property/UploadFile`;
      await axios.post(url, fd, config).then((response) => {
        const { data } = response;
        if (data?.result?.failedresult?.length > 0) {

          const failedArry = _.map(data.result.failedresult, (e) => {
            return {
              "businessunit": e.businessunit,
              "buildingname": e.buildingname,
              "propertycode": e.propertycode,
              "unitcode": e.unitcode,
              "reason": e.reason
            }
          });
          setFailed(failedArry);
        }
        if (data?.result?.successResultCount) {
          setSuccess({ unit: data?.result?.successResultCount?.bulkDataToCreateUnitCount, building: data?.result?.successResultCount?.bulkDataToCreateBuildingCount });
          message.success(response.data.message);
          props.onSubmit();
        }
        setLoading(false);
        setProperty([]);

      }).catch((error) => {

        setLoading(false);
        message.error(error.response.data.error)

      })

    } else {
      setLoading(false);
      message.error("Please select a file to upload");
    }

  };


  const propertyFileProps = {
    className: "file-upload",
    name: "file",
    accept: UPLOAD_CONFIG.CSV.accept,
    multiple: false,
    // showUploadList: false,
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {

      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} Please upload only CSV file`);
      }
    },
    onDrop(e) {

      // setProperty(e.dataTransfer.files);
    },
    onRemove: (file) => {
      setProperty([]);
    },
    beforeUpload: (file) => {
      setProperty([file]);
      return false;
    },
    propertyFile,
  };


  return (

  <>

   { 
    !props?.addSinglePropertyFlag ?
    
    <Layout className="layout-space prop_popup">
      <Content className="main-content">
         
        <Row gutter={24}>

          <Col flex="1 1 500px">
            {/* File Uploader */}
            <div style={{ textAlign: "center" }}>
        
              <Form layout="vertical" onFinish={handleSubmit(onFinish)}>

                    <Row gutter={24}>
                      <Dragger {...propertyFileProps}
                        fileList={propertyFile}

                        className="drag_drop_csv">
                        <p className="ant-upload-drag-icon">
                          <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                        <p className="ant-upload-hint">
                          Download the sample template and fill the data as per the template, convert master file into CSV and upload it.
                          <br></br><br></br>
                          <span>Note: </span>{`Only ${formatFileExtensions(propertyFileProps?.accept)} files are accepted.`}
                        </p>
                      </Dragger>
                      <div className="csvmodel">
                        <a className="downloadcsv" href={`${serverUrl}/templates/residential/ResidentialBuildingAndUnitTemplate_v1.xlsx`} download>
                          {<BsDownload />}  Download residential template file
                        </a>
                        <a className="downloadcsv" href={`${serverUrl}/templates/commercial/CommercialBuildingAndUnitTemplate_v1.xlsx`} download>
                          {<BsDownload />} Download commercial template file
                        </a>

                        <a className="downloadcsv" onClick={() => props?.setSinglePropertyFlag(true)} href="javascript:void(0)">
                          {<PlusCircleOutlined />} Add Single Property
                        </a>
                      </div>
                      <Col span={24} className="csv_error_wrap">
                        {loading ? (
                          <Spin />
                        ) :

                          (<>

                            {successData.building || successData.unit ?
                              (
                                <p className="success_csv">{<BsFillCheckCircleFill />}
                                  {status()}
                                </p>
                              )
                              : ""}

                            {failedData?.length > 0 ? (
                              <div className="csv_error_log">
                                <span className="csv_error"> {<BsXCircleFill color='red' />} {failedData?.length} - Records Failed <CSVLink className="csv_log" {...csvReport}>{<BsDownload />} Download Failure Log</CSVLink></span><br />
                                {/* <span className="csv_log"><CSVLink {...csvReport}>Download Failure Log</CSVLink></span> */}
                              </div>
                            ) : ""}

                          </>)}
                        <Button htmlType="submit" disabled={loading} type="primary" size="large" className="csv_publish">
                          {<BsCloudUpload />}Publish
                        </Button>
                      </Col>


                    </Row>
                            
              </Form>

              <br />
            </div>
          </Col>

        </Row>
      </Content>
    </Layout>
    :
      <AddSingleProperty 
       addSinglePropertyFlag={props?.addSinglePropertyFlag}
       setSinglePropertyFlag={props?.setSinglePropertyFlag}
        onSubmit = {props.onSubmit}
        setVisible={props?.setVisible}
        />
   }

  </>
  );
};
